import { Component, OnInit,Input,SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-ratios-table',
    templateUrl: './ratios-table.component.html',
    styleUrls: ['./ratios-table.component.scss'],
    standalone: false
})
export class RatiosTableComponent implements OnInit {

  @Input() _isAnnual:boolean=true;


  // @Input() quickRatioAnnualArray: any[] = [];
  // @Input() cashRatioAnnualArray: any[] = [];
  // @Input() peTtmAnnualArray: any[] = [];
  // @Input() psTtmAnnualArray:any[] = [];
  // @Input() fcfMarginAnnualArray:any[]=[]
  // @Input() payoutRatioAnnualArray:any[]=[]
  // @Input() grossMarginAnnualArray:any[]=[]
  // @Input() roeAnnualArray:any[]=[]
  // @Input() roaAnnualArray:any[]=[]
  // @Input() roaTtmAnnualArray:any[]=[]
  // @Input() roicAnnualArray:any[]=[]
  // @Input() inventoryTurnoverTtmAnnualArray:any[]=[]
  // @Input() receivablesTurnoverTtmAnnualArray:any[]=[]
  // @Input() assetTurnoverTtmAnnualArray:any[]=[]
  // @Input() longTermDebttoEquityAnnualArray:any[]=[]
  // @Input() debtToAssetAnnualArray:any[]=[]
  // @Input() longTermDebttoTotalAssestAnnualArray:any[]=[]
  // @Input() debtToCapitalAnnualArray:any[]=[]
  // @Input() pbAnnualArray:any[]=[]
  // @Input() netMarginAnnualArray:any[]=[]
  // @Input() operatingMarginAnnualArray:any[]=[]

  // @Input() quickRatioQuarterlyArray: any[] = [];
  // @Input() cashRatioQuarterlyArray: any[] = [];
  // @Input() peTtmQuarterlyArray: any[] = [];
  // @Input() psTtmQuarterlyArray:any[] = [];
  // @Input() fcfMarginQuarterlyArray:any[]=[]
  // @Input() payoutRatioQuarterlyArray:any[]=[]
  // @Input() grossMarginQuarterlyArray:any[]=[]
  // @Input() roeQuarterlyArray:any[]=[]
  // @Input() roaQuarterlyArray:any[]=[]
  // @Input() roaTtmQuarterlyArray:any[]=[]
  // @Input() roicQuarterlyArray:any[]=[]
  // @Input() inventoryTurnoverTtmQuarterlyArray:any[]=[]
  // @Input() receivablesTurnoverTtmQuarterlyArray:any[]=[]
  // @Input() assetTurnoverTtmQuarterlyArray:any[]=[]
  // @Input() longTermDebttoEquityQuarterlyArray:any[]=[]
  // @Input() debtToAssetQuarterlyArray:any[]=[]
  // @Input() longTermDebttoTotalAssestQuarterlyArray:any[]=[]
  // @Input() debtToCapitalQuarterlyArray:any[]=[]
  // @Input() pbQuarterlyArray:any[]=[]
  // @Input() netMarginQuarterlyArray:any[]=[]
  // @Input() operatingMarginQuarterlyArray:any[]=[]
  @Input() allDataAnnual:any[]=[]
  @Input() aDataQuarterly:any[]=[]
  @Input() bDataQuarterly:any[]=[]
  @Input() cDataQuarterly:any[]=[]
  @Input() dDataQuarterly:any[]=[]
  @Input() price_to_earning: number[] = [];
  formattedPriceToEarning: any[] = [];

  noDataAnnual:boolean=false
  noDataQuarterly:boolean=false

  years = [2020, 2021, 2022, 2023, 2024];
  quarters: string[] = []; // Will be populated dynamically from the data

  constructor() { }



   ngOnInit(): void {
     this.extractQuartersFromData();
     this.checkDataAvailability();
     this.mapPriceToEarning();
   }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.allDataAnnual ||
        changes.aDataQuarterly ||
        changes.bDataQuarterly ||
        changes.cDataQuarterly ||
        changes.dDataQuarterly) {
      this.extractQuartersFromData();
      this.checkDataAvailability();

      if (changes['price_to_earning'] && !changes['price_to_earning'].firstChange) {
         this.mapPriceToEarning();
       }
    }
  }

  private extractQuartersFromData(): void {
    const allQuarters = new Set<string>();

    // Collect quarters from all quarterly data arrays
    [this.aDataQuarterly, this.bDataQuarterly, this.cDataQuarterly, this.dDataQuarterly].forEach(dataArray => {
      if (dataArray && Array.isArray(dataArray)) {
        dataArray.forEach(record => {
          Object.keys(record).forEach(key => {
            // Check if key matches quarter pattern (Q1'24, Q2'25, etc.)
            if (key.match(/^Q[1-4]'\d{2}$/)) {
              allQuarters.add(key);
            }
          });
        });
      }
    });

    // Sort quarters by year and quarter (latest first), then take only 4 latest
    const sortedQuarters = Array.from(allQuarters).sort((a, b) => {
      const aYear = parseInt('20' + a.split("'")[1]);
      const bYear = parseInt('20' + b.split("'")[1]);
      const aQuarter = parseInt(a.split("'")[0].substring(1));
      const bQuarter = parseInt(b.split("'")[0].substring(1));

      if (aYear !== bYear) return bYear - aYear; // Latest year first
      return bQuarter - aQuarter; // Latest quarter first
    });

    // Take only the 4 latest quarters and reverse to show latest on right
    this.quarters = sortedQuarters.slice(0, 4).reverse();

  }

  private mapPriceToEarning(): void {
   if (!this.price_to_earning || this.price_to_earning.length === 0) {
     this.formattedPriceToEarning = [];
     return;
   }

   // Ensure the object can have dynamic year properties
   const row: { name: string; [key: string]: string | number } = { name: 'Price to Earning' };

   // Populate the row with year values
   this.years.forEach((year, index) => {
     row[year.toString()] = this.price_to_earning[index] ?? '-';
   });

   // Check if any value is valid (not just '-')
   const hasValidData = this.years.some(year => row[year.toString()] !== '-');

   // Only add the row if there is valid data
   this.formattedPriceToEarning = hasValidData ? [row] : [];
 }




  private hasValidData(item: any): boolean {
    // If item is null or undefined, it's not valid
    if (item === null || item === undefined) {
      return false;
    }

    // If item is an object (like your year data)
    if (typeof item === 'object' && !Array.isArray(item)) {
      // Filter out 'name' or any other metadata properties
      const values = Object.entries(item)
        .filter(([key]) => !isNaN(Number(key))) // Only check year properties
        .map(([_, value]) => value);

      // Check if any of the year values are non-null
      return values.some(value => value !== null && value !== undefined);
    }

    // For other types, just check if it has a value
    return true;
  }

  private isDataEmpty(arr: any[]): boolean {
    // Check if array is undefined, null, or empty
    if (!arr || !Array.isArray(arr) || arr.length === 0) {
      return true;
    }

    // Check if array has any valid data
    return !arr.some(item => this.hasValidData(item));
  }

  private checkDataAvailability(): void {
     // Check annual data
     this.noDataAnnual = this.isDataEmpty(this.allDataAnnual);

     // Check quarterly data using dynamic quarters
     const quarters = this.quarters.length > 0 ? this.quarters : ["Q1'24", "Q2'24", "Q3'24", "Q4'24"];

   // Function to remove records without any valid quarterly data
   const filterValidData = (dataArray: any[]) => {
     return dataArray.filter(record =>
       quarters.some(quarter => record[quarter] !== null && record[quarter] !== undefined && record[quarter] !== '')
     );
   };

   // Filter each dataset to remove empty rows
   this.aDataQuarterly = filterValidData(this.aDataQuarterly);
   this.bDataQuarterly = filterValidData(this.bDataQuarterly);
   this.cDataQuarterly = filterValidData(this.cDataQuarterly);
   this.dDataQuarterly = filterValidData(this.dDataQuarterly);

   // Check if any quarterly data remains
   this.noDataQuarterly =
     this.aDataQuarterly.length === 0 &&
     this.bDataQuarterly.length === 0 &&
     this.cDataQuarterly.length === 0 &&
     this.dDataQuarterly.length === 0;
   }




  isRowEmpty(record: any): boolean {
    return this.years.every(year => !record[year] || record[year] === null || record[year] === '');
  }
  isQuarterlyRowEmpty(record: any): boolean {
    const quarters = this.quarters.length > 0 ? this.quarters : ["Q1'24", "Q2'24", "Q3'24", "Q4'24"];
    return quarters.every(quarter => !record[quarter] || record[quarter] === null || record[quarter] === '');
  }



  getValueForYear(year: number, dataArray: any[]): string {
   const matchingValue = dataArray.find(value => {
     if (!value.document?.period) return false; // Ensure period exists
     const periodYear = new Date(value.document.period).getFullYear();
     return periodYear === year;
   });

   return matchingValue ? matchingValue.document.v.toString() : '-';
 }

 getKeys(obj: any): string[] {
  return Object.keys(obj);
}

roundToTwoDecimals(value: any): number | null {
   const num = Number(value);
   if (isNaN(num)) return null;
   return parseFloat(num.toFixed(2));
 }

hasNonNullValue(array: (number | null)[]): boolean {
   return array.some(value => value !== null);
}


 getValueForQuarter(quarter: string, dataArray: any[]): string {
   const [q, year] = quarter.split("'");  // Split "Q4'23" into "Q4" and "23"
   const quarterMap: { [key: string]: string } = {
     'Q1': '03-30',
     'Q2': '06-29',
     'Q3': '09-28',
     'Q4': '12-28'
   };

   // Construct the period string (e.g., "2023-12-31")
   const period = `20${year}-${quarterMap[q]}`;

   const matchingValue = dataArray.find(value => {
     if (!value.document?.period) return false;
     return value.document.period === period;
   });

   return matchingValue ? matchingValue.document.v.toString() : '-';
 }

 getLabel(name: string): string {
  const labels: { [key: string]: string } = {
    netMargin: "Net Margin",
    quickRatio: "Quick Ratio",
    currentRatio: "Current Ratio",
    peTTM: "Price to Earnings (TTM)",
    psTTM: "Price to Sales (TTM)",
    fcfMargin: "Free Cash Flow Margin",
    payoutRatioTTM: "Payout Ratio (TTM)",
    grossMargin: "Gross Margin",
    roeTTM: "Return on Equity (TTM)",
    roa: "Return on Assets",
    roaTTM: "Return on Assets (TTM)",
    roic: "Return on Invested Capital",
    inventoryTurnoverTTM: "Inventory Turnover (TTM)",
    receivablesTurnoverTTM: "Receivables Turnover (TTM)",
    assetTurnoverTTM: "Asset Turnover (TTM)",
    longtermDebtTotalEquity: "Long-Term Debt to Equity",
    totalDebtToTotalAsset: "Total Debt to Total Asset",
    longtermDebtTotalAsset: "Long-Term Debt to Total Asset",
    totalDebtToTotalCapital: "Total Debt to Total Capital",
    operatingMargin: "Operating Margin",
    pb:"Price to Book"
  };
  return labels[name] || name; // Default to name if no label found
}

}
